import { messageWidgets } from './message_widgets';

export { messageWidgets };

// Every capability the registry recognises. A plugin field not listed here is
// rejected at registration time rather than silently ignored, so `messageWidget`
// (singular) is caught instead of quietly rendering nothing.
export const CAPABILITIES = [messageWidgets];
